export default __webpack_public_path__ + "static/media/meet2seat.2467f897.svg";